import { Injectable } from '@angular/core';

@Injectable()
export class FilterTextService {
  constructor() { }

  filter(data: string, props: Array<string>, originalList: Array<any>) {
    return originalList ?
      originalList.filter(item => this.filterItem(data, props, item)) :
      originalList;
  }

  filterItem(data: string, props: Array<string>, item: any) {
    if (data && props && item) {
      let match = false;
      data = data.toLowerCase();
      for (const prop of props) {

        let itemValue: any = item;
        const propChunks = prop.split('.');
        for (let i = 0; i < propChunks.length; i++) {
          if (itemValue) {
            itemValue = itemValue[propChunks[i]];
          }
        }

        if (itemValue && itemValue.toString().toLowerCase().indexOf(data) > -1) {
          match = true;
          break;
        }
      }
      return match;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-text/filter-text.service.ts